// IMPORTANT NOTE: when adding new fields to the filter model, make sure to also add them to the filter when importing project planning

export class FilterModel {

  rating_from = null;
  rating_to = null;
  client_rating_from = null;
  client_rating_to = null;
  preselected_employee_ids = [];
  deselected_employee_ids = [];
  employee_lists = [];
  additional_employee_lists = [];
  employee_black_lists  = [];
  and_additional = null;
  include_blocked_employees = false;
  public_pool = false;
  name = null;
  gender_m = null;
  gender_f = null;
  gender_o = null;
  warnings = [];
  future_jobs_from = null;
  future_jobs_to = null;
  job_history_from = null;
  job_history_to = null;
  imported_job_history_from = null;
  imported_job_history_to = null;
  age_from = null;
  age_to = null;
  number_of_children_from = null;
  number_of_children_to = null;
  smoker_yes = false;
  smoker_no = false;
  has_video_self_portrait_yes = false;
  has_video_self_portrait_no = false;
  visible_tattoo_yes = false;
  visible_tattoo_no = false;
  visible_piercing_yes = false;
  visible_piercing_no = false;
  distance_from_main_location = 0;
  distance_from_second_location = 0;
  main_address = null;
  second_address = null;
  main_address_valid_from_from = null;
  main_address_valid_from_to = null;
  second_address_valid_from_from = null;
  second_address_valid_from_to = null;
  eye_color = [];
  has_logged_in: any;

  has_ssn_number_yes = false;
  has_ssn_number_no = false;
  employee_no_from = null;
  employee_no_to = null;
  has_iban_yes = false;
  has_iban_no = false;
  bank_account_types = [];
  has_account_no_yes = false;
  has_account_no_no = false;
  bank_name = null;
  bank_location = null;
  clearing_no = null;
  has_ssn_yes = false;
  has_ssn_no = false;
  marital_status_valid_from_from = null;
  marital_status_valid_from_to = null;
  consultant_name = null;

  registration_date_from = null;
  registration_date_to = null;
  date_of_application_from = null;
  date_of_application_to = null;
  interview_date_from = null;
  interview_date_to = null;
  activation_date_from = null;
  activation_date_to = null;
  first_day_of_work_from = null;
  first_day_of_work_to = null;
  inactivation_date_from = null;
  inactivation_date_to = null;
  last_mobile_login_from = null;
  last_mobile_login_to = null;
  has_pass_yes = false;
  has_pass_no = false;
  has_workpermit_upload_yes = false;
  has_workpermit_upload_no = false;
  work_permit_expiry_from = null;
  work_permit_expiry_to = null;
  has_basic_agreement_yes = false;
  has_basic_agreement_no = false;

  body_height_from = null;
  body_height_to = null;
  hair_color = [];
  ethnicity = [];
  shoe_size_from = null;
  shoe_size_to = null;
  shirt_size_from = null;
  shirt_size_to = null;
  trouser_width_from = null;
  trouser_width_to = null;
  trouser_length_from = null;
  trouser_length_to = null;
  marital_status = [];
  nationality = [];
  branch_types = [];
  client_pool_ids = [];
  client_pool_and = false;
  // JS-1871 Self Service 2c — client-scoped "My Lists" filter.
  client_employee_lists = [];
  client_employee_list_and = false;
  other_branches = false;
  consultant_types = [];
  work_permit = [];
  is_permanent = null;
  permanent_staff = null;
  is_internal = null;
  availability_filter = false;
  strict_availability_filter = false;
  educations = [];
  education_and = false;
  experiences = [];
  experience_and = false;
  languages = [];
  language_and = false;

  public_none = false;
  public_half_tax = false;
  public_ga = false;
  public_regional_network = false;
  public_regional_network_name = null;

  l_a1 = false;
  l_a = false;
  l_b = false;
  l_be = false;
  l_c = false;
  l_ce = false;
  l_c1 = false;
  l_c1e = false;
  l_d = false;
  l_d1 = false;
  l_d1e = false;
  l_de = false;
  l_f = false;
  l_g = false;
  l_m = false;

  car_own_car = false;
  car_in_household = false;
  car_no_car = false;
  car_brand = [];
  car_body_type = [];
  car_size = [];
  car_mobility = false;
  car_gomore = false;
  car_2em = false;
  car_other = false;

  has_driver_licence_upload_yes = false;
  has_driver_licence_upload_no = false;
  driver_skill_automatic = false;
  driver_skill_manual = false;
  driver_skill_t5 = false;
  driver_skill_lift = false;

  sport = false;
  tobacco = false;
  logistics = false;
  promoter = false;
  promotor = false;
  merchandising = false;
  mystery_shopping = false;
  reception = false;
  service = false;
  bar = false;
  kitchen = false;
  security = false;
  care = false;
  cleaning = false;
  alcoholic_beverages = false;
  automotive = false;
  telecommunication = false;
  financial_products = false;
  pharmaceutical_products = false;
  food = false;
  beauty_body_care = false;
  it = false;
  nonfoods = false;
  pet = false;

  has_internal_remark_yes = false;
  has_internal_remark_no = false;

  has_image_1_yes = false;
  has_image_1_no = false;
  has_image_2_yes = false;
  has_image_2_no = false;
  has_image_3_yes = false;
  has_image_3_no = false;
  has_image_4_yes = false;
  has_image_4_no = false;
  has_image_5_yes = false;
  has_image_5_no = false;
  has_image_6_yes = false;
  has_image_6_no = false;

  has_cv_yes = false;
  has_cv_no = false;

  inactive_status = false;
  active_status = true;
  incomplete_status = false;
  applied_status = false;
  edited_status = false;
  expired_status = false;

  weekly_availabilities = [];
  availablePeriods = [];

  latitude = null;
  longitude = null;
  and = null;
  id = null;

  showFilterAvailabilityChbx = false;

  is_deselect_clicked = false;
  client_id: any;

  additional_documents_filter: any = {};
}

export class ProfessionalExperienceFilterModel {
  profession = null;
  job_title = null;
  from_after = null;
  from_before = null;
  to_after = null;
  to_before = null;
  is_current = false;
}

export class EducationFilterModel {
  diploma = null;
  from_after = null;
  from_before = null;
  to_after = null;
  to_before = null;
  is_current = false;
  has_certificate_yes = false;
  has_certificate_no = false;
}

export class LanguageModel {
  name = null;
  level = null;
  has_certificate_yes = false;
  has_certificate_no = false;
}

export class AvailabilityModel {
  day = '';
  from = '';
  to = '';
}


